var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPulseLinear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-4h24v24H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.027.77c.224-.951 1.516-1.033 1.886-.18l.043.117 2.576 8.407 1.077-2.107a1 1 0 01.767-.538l.124-.007H21a1 1 0 01.117 1.993L21 8.462l-3.888-.001-1.921 3.763c-.39.764-1.479.705-1.806-.05l-.041-.112-2.219-7.239L8.67 15.23c-.226.958-1.53 1.032-1.892.168l-.041-.118L4.749 8.46H1a1 1 0 01-.993-.883L0 7.462a1 1 0 01.883-.994L1 6.462h4.5a1 1 0 01.92.607l.04.113 1.135 3.894L10.027.77z",
    fill: "#151A30"
  }))));
}

export default SvgPulseLinear;